// extracted by css-extract-rspack-plugin
export default {"root":"src-components-NodeStatus-NodeStatus-module__root-QfM_bG"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"root\":\"src-components-NodeStatus-NodeStatus-module__root-QfM_bG\"}";
        // 1772473573004
        var cssReload = require("../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  